import { useEffect } from 'react';

import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';

import { getMyTasks } from 'src/redux/slices/reorder-settings';
import { useAppDispatcher, useAppSelector } from 'src/redux/store';

import EmptyContent from 'src/components/empty-content';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { IReorderSettingsRow } from 'src/types/reorder-settings';

import MyTasksCard from '../my-tasks-card';

export default function MyTasksView() {
  const { myTasksStatus, myTasks } = useAppSelector((state) => state.reorderSettings);

  const dispatch = useAppDispatcher();

  const settings = useSettingsContext();

  useEffect(() => {
    dispatch(getMyTasks());
  }, [dispatch]);

  let content: React.ReactNode;

  if (myTasksStatus === 'loading') {
    content = (
      <Grid container spacing={3}>
        {[...Array(6)].map((_, index) => (
          <Grid key={index} xs={12} sm={6} md={4}>
            <Card sx={{ p: 2.5 }}>
              <Skeleton variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="30%" />
              <Skeleton variant="rectangular" height={60} sx={{ mt: 2, borderRadius: 1 }} />
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  } else if (myTasks.length === 0) {
    content = (
      <EmptyContent
        filled
        title="All caught up"
        description="Nothing assigned to you is currently low or out of stock."
        sx={{ py: 10, height: 'auto' }}
      />
    );
  } else {
    content = (
      <Grid container spacing={3}>
        {myTasks.map((row: IReorderSettingsRow) => (
          <Grid key={row._id} xs={12} sm={6} md={4}>
            <MyTasksCard row={row} />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="My Tasks"
        links={[]}
        sx={{
          mb: { xs: 3 },
        }}
      />

      {content}
    </Container>
  );
}
